import { render } from "./inline-card.vue?vue&type=template&id=a6c91cdc"
import script from "./inline-card.vue?vue&type=script&lang=js"
export * from "./inline-card.vue?vue&type=script&lang=js"

import "./inline-card.vue?vue&type=style&index=0&id=a6c91cdc&lang=scss"

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__